var SharingCodeErrorCode = /*#__PURE__*/function (SharingCodeErrorCode) {
  SharingCodeErrorCode[SharingCodeErrorCode["CODE_NOT_FOUND"] = 57] = "CODE_NOT_FOUND";
  SharingCodeErrorCode[SharingCodeErrorCode["INCORRECT_YOB"] = 56] = "INCORRECT_YOB";
  SharingCodeErrorCode[SharingCodeErrorCode["INVALID_YOB"] = 4] = "INVALID_YOB";
  return SharingCodeErrorCode;
}(SharingCodeErrorCode || {});
export default SharingCodeErrorCode;